class Rating {
  constructor(node) {
    this.rootElement = node;
    this.positiveButton = this.rootElement.querySelector('[data-item-positive]');
    this.negativeButton = this.rootElement.querySelector('[data-item-negative]');
    this.commentSection = this.rootElement.querySelector('.js-rate-with-comment-container');
    this.leaveComment = this.rootElement.querySelector('[data-rate-w-comment]');

    this.positiveButton.addEventListener('click', this.ratePositively.bind(this));
    this.negativeButton.addEventListener('click', this.rateNegatively.bind(this));
    this.leaveComment.addEventListener('click', this.rateWithComment.bind(this));
  }

  ratePositively() {
    const uid = this.positiveButton.getAttribute('data-item-positive');
    const foreignTable = this.positiveButton.getAttribute('data-foreign-table');
    const pageId = document.querySelector('body').getAttribute('data-page-uid');

    this.submitRating(uid, foreignTable, 1, '', pageId);
    this.positiveButton.style.transition = 'opacity 1s';
    this.positiveButton.style.opacity = 0;
    this.positiveButton.remove();
  }

  rateNegatively() {
    if (this.commentSection.classList.contains('is-hidden')) {
      this.commentSection.classList.remove('is-hidden');
      this.negativeButton.style.transition = 'opacity 1s';
      this.negativeButton.style.opacity = 0.5;
      this.negativeButton.setAttribute('disabled', 'disabled');
    }
  }

  rateWithComment() {
    const uid = this.leaveComment.getAttribute('data-rate-w-comment');
    const foreignTable = this.leaveComment.getAttribute('data-foreign-table');
    const comment = this.commentSection.querySelector(`#comment-item-${uid}-${foreignTable}`);
    const pageId = document.querySelector('body').getAttribute('data-page-uid');
    this.submitRating(uid, foreignTable, 0, comment.value, pageId);
    this.leaveComment.style.transition = 'opacity 1s';
    this.leaveComment.style.opacity = 0.5;
    this.leaveComment.setAttribute('disabled', 'disabled');
  }

  submitRating(uid, foreignTable, rating, comment, pageId) {
    const ratingApiPageUrl = this.rootElement.closest('.c-accordion').getAttribute('data-gs1-rating-api-url');
    const data = {
      tx_gs1rating_rating: {
        apiAction: 'rateItem',
        uid: parseInt(uid, 10),
        foreignTable: foreignTable,
        rating: parseInt(rating, 10),
        comment: comment,
        pageId: parseInt(pageId, 10)
      }
    };

      fetch(ratingApiPageUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        cache: 'no-cache'
      })
        .then(response => response.json())
        .then(response => {
          const alert = 'alert-' + uid + '-' + foreignTable;
          const alertMarkup = `
            <div class="c-alert c-alert--success">
              <div class="c-alert__bar">
                  <p class="c-alert__message">${response.message}</p>
              </div>
            </div>`;
          document.querySelector('#rating-form-' + uid + '-' + foreignTable).insertAdjacentHTML('afterbegin', alertMarkup);

          setTimeout(function () {
            const element = document.getElementById(alert);
            if (element) {
              element.style.transition = 'opacity 1s';
              element.style.opacity = 0;
              setTimeout(function () {
                element.parentNode.removeChild(element);
              }, 1000);
            }
          }, 4000);
        })
      .catch(error => {
        console.error('Error:', error);
      });
  }
}

const ratings = document.querySelectorAll('.js-rating-form');
ratings.forEach((rating) => {
  new Rating(rating);
});
